$(document).on('turbolinks:load', function() {	
    $("#platform_key_platform_id").change(function () {	
      id = this.value;	
      $.ajax({	
        type: "GET",	
        url: "/platforms/"+id,	
        dataType: "script"	
      });    	
    });	
  });